import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <div className="theme-toggle">
      <input
        type="checkbox"
        id="theme-toggle-switch"
        className="theme-toggle-checkbox"
        checked={theme === 'dark'}
        onChange={toggleTheme}
        aria-label="Toggle dark mode"
      />
      <label htmlFor="theme-toggle-switch" className="theme-toggle-label">
        <span className="theme-toggle-inner">
          <Sun className="sun-icon" size={13} aria-hidden="true" />
          <Moon className="moon-icon" size={13} aria-hidden="true" />
        </span>
        <span className="theme-toggle-switch"></span>
      </label>
    </div>
  );
};

export default ThemeToggle;